import { AxiosResponse } from "axios";
import { ApiResponse } from "@/shared/types/api.ts";
import axiosClient from "@/shared/lib/axios/axios.ts";
import { API_ROUTES } from "@/locations/api/config.ts";
import { TLocation } from "@/locations/types/location.ts";
import { useOrganizationStore } from "@/shared/stores/useOrganizationStore";

export interface IGetLocationsInput {}

export type IGetLocationsResponse = TLocation

export const getAllLocations = async () => {
  const { selectedOrganizationId } = useOrganizationStore.getState();

  // Ensure we have organization ID before making request
  if (!selectedOrganizationId) {
    throw new Error('Organization ID is required');
  }

  return axiosClient
    .get<IGetLocationsInput, AxiosResponse<ApiResponse<IGetLocationsResponse[]>>>(
      API_ROUTES.LOCATION,
      {
        params: {
          organization_id: selectedOrganizationId
        }
      }
    )
    .then((res) => res.data);
};

export interface IGetLocationByIdInput {
  id: number;
}

export type IGetLocationByIdResponse = TLocation

export const getLocationById = async (id: number) => {
  const { selectedOrganizationId } = useOrganizationStore.getState();

  // Ensure we have organization ID before making request
  if (!selectedOrganizationId) {
    throw new Error('Organization ID is required');
  }

  return axiosClient
    .get<IGetLocationByIdInput, AxiosResponse<ApiResponse<IGetLocationByIdResponse>>>(
      `${API_ROUTES.LOCATION}${id}/`,
      {
        params: {
          organization_id: selectedOrganizationId
        }
      }
    )
    .then((res) => res.data);
};
